import DateTime from './DateTime';
import { isEmpty } from 'lodash';

const format = value => {
  const days = value.getDate() > 9 ? value.getDate() : `0${value.getDate()}`;
  const months = value.getMonth() + 1 > 9 ? value.getMonth() + 1 : `0${value.getMonth() + 1}`;
  const hours = value.getHours() > 9 ? value.getHours() : `0${value.getHours()}`;
  const minutes = value.getMinutes() > 9 ? value.getMinutes() : `0${value.getMinutes()}`;
  return `${value.getFullYear()}-${months}-${days}T${hours}:${minutes}`;
};

const formatUTC = value => {
  const days = value.getUTCDate() > 9 ? value.getUTCDate() : `0${value.getUTCDate()}`;
  const months = value.getUTCMonth() + 1 > 9 ? value.getUTCMonth() + 1 : `0${value.getUTCMonth() + 1}`;
  const hours = value.getUTCHours() > 9 ? value.getUTCHours() : `0${value.getUTCHours()}`;
  const minutes = value.getUTCMinutes() > 9 ? value.getUTCMinutes() : `0${value.getUTCMinutes()}`;
  return `${value.getUTCFullYear()}-${months}-${days}T${hours}:${minutes}`;
};

const formatToISOString = value => {
  const datumObjekt = new Date(value);
  // Preformátovanie dátumu na požadovaný formát ISO s časom v UTC
  return datumObjekt.toISOString();
};

const convertToDate = (value, { useUTC, dateOnly }) => {
  if (!value) return undefined;
  if (value instanceof Date) return value;
  if (!dateOnly && /[Zz]|[+-]\d{2}:?\d{2}$/.test(value)) {
    return new Date(value);
  }
  const pattern = dateOnly
    ? /(\d{1,2})\.(\d{1,2})\.(\d{4})/
    : /(\d{1,2})\.(\d{1,2})\.(\d{4})\s?(\d{1,2})?:?(\d{1,2})?/;
  const match = value.match(pattern);
  if (match !== null) {
    return new Date(value.replace(pattern, '$3-$2-$1 $4:$5'));
  }
  const fields = dateOnly
    ? [value.substring(0, 4), value.substring(5, 7) - 1, value.substring(8, 10)]
    : [value.substring(0, 4), value.substring(5, 7) - 1, value.substring(8, 10), value.substring(11, 13), value.substring(14, 16)];
  if (!isEmpty(value)) {
    return useUTC ? new Date(Date.UTC(...fields)) : new Date(...fields);
  }
};

export default function FormDateTime({
  input: { onChange, value, ...rest },
  meta: { touched, error },
  updateField,
  changeFieldFunc,
  useUTC,
  useISO,
  dateOnly,
  ...props
}) {
  const handleChange = val => {
    //TODO need better fix
    if (val === '') {
      onChange('');
      return;
    }
    const dt = useUTC ? formatUTC(val) : useISO ? formatToISOString(val) : format(val);
    const newVal = dateOnly ? dt.substring(0, 10) : dt;
    onChange(newVal);
    if (updateField && changeFieldFunc) {
      changeFieldFunc(updateField.field, newVal);
    }
  };

  return (
    <DateTime
      errorText={touched && error}
      value={convertToDate(value, { useUTC, dateOnly })}
      onChange={handleChange}
      dateOnly={dateOnly}
      {...rest}
      {...props}
    />
  );
}
